import { motion } from "framer-motion";
import { ECOSYSTEM_NODES } from "../../data/content";
import { reveal } from "../../lib/motion";

export const Ecosystem = () => {
  return (
    <section
      data-testid="ecosystem-section"
      className="overflow-hidden bg-creamalt py-16 md:py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <motion.p
          {...reveal()}
          className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-gold"
        >
          O Grande Ecossistema
        </motion.p>
        <motion.h2
          {...reveal(0.1)}
          className="mt-4 text-center font-serif text-3xl text-ink sm:text-4xl lg:text-5xl"
        >
          Um ciclo vivo de <em className="italic text-teal">fé, serviço e legado</em>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="ecosystem-diagram"
          className="relative mx-auto mt-16 h-[320px] w-[320px] sm:h-[520px] sm:w-[520px]"
        >
          <div className="animate-spin-slower absolute inset-0 rounded-full border border-dashed border-gold/50" />
          <div className="absolute inset-[18%] rounded-full border border-gold/30" />
          <div className="absolute left-1/2 top-1/2 flex h-28 w-28 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-teal text-center shadow-[0_0_60px_rgba(27,139,139,0.4)] sm:h-40 sm:w-40">
            <span className="px-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-white sm:text-xs">
              Ministério AURA
            </span>
          </div>
          {ECOSYSTEM_NODES.map((node, i) => {
            const angle = ((i * 40 - 90) * Math.PI) / 180;
            const left = 50 + 41 * Math.cos(angle);
            const top = 50 + 41 * Math.sin(angle);
            return (
              <motion.div
                key={node}
                data-testid={`ecosystem-node-${i}`}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: 0.15 * i, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full border border-gold-border bg-white px-3 py-1.5 shadow-[0_8px_24px_rgba(197,160,89,0.15)] sm:px-5 sm:py-2.5"
                style={{ left: `${left}%`, top: `${top}%` }}
              >
                <span className="whitespace-nowrap text-[8px] font-semibold uppercase tracking-[0.15em] text-ink sm:text-[11px]">
                  {node}
                </span>
              </motion.div>
            );
          })}
        </motion.div>

        <motion.p
          {...reveal()}
          data-testid="ecosystem-flow-caption"
          className="mx-auto mt-16 max-w-3xl text-center text-xs uppercase leading-loose tracking-[0.15em] text-mutedink sm:text-sm"
        >
          MINISTÉRIO AURA → MISS AURA → EMBAIXADORAS → PROFISSIONAIS → CLIENTES
          → SERVIÇOS → TREINAMENTOS → CARIDADE → LEGADO →{" "}
          <span className="text-teal">e tudo retorna à Comunidade.</span>
        </motion.p>
      </div>
    </section>
  );
};
